import {
    Create,
    SimpleForm,
    SelectInput,
    TextInput,
    required,
} from 'react-admin';
import { nokTypes, nokStatuses } from "../../defaults/defaults";
import { JSX  } from "react";
import {
    Grid,
    Stack,
    Box
} from '@mui/material';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const NokCreate: () => JSX.Element = (): JSX.Element => {
    return (
        <Create redirect="edit">
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput source="name"
                                   validate={[required()]}
                                   fullWidth/>
                        <TextInput source="systemCode"
                                   validate={[required()]}
                                   fullWidth/>
                        <TextInput source="description"
                                   multiline
                                   fullWidth
                                   rows={ 5 }
                                   validate={[required()]}
                                   helperText="This text is displayed to the customer"/>
                        <TextInput source="operatorId"
                                   label="Operator ID"
                                   helperText="This ID is used to identify the Operator process needed to be run. Once saved, this is uneditable"
                                   validate={[required()]}
                                   fullWidth/>
                        <SelectInput source="status"
                                     choices={ nokStatuses }
                                     defaultValue="testing"
                                     fullWidth
                                     validate={[required()]}
                                     helperText="Only Active Noks are shown to customers."
                        />
                        <SelectInput source="type"
                                     choices={ nokTypes }
                                     defaultValue="simple"
                                     fullWidth
                                     validate={[required()]}/>
                    </Grid>
                    <Grid size={ 6 }>
                        <span>{ "Configuration and testing is available when editing, you will be redirected on saving" }</span>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
